import { Controller } from "@hotwired/stimulus"

// Keeps a <details> panel open across Turbo Stream broadcasts and full-page
// reloads. The live game card gets replaced (broadcast_replace_to) every
// time the referee taps a goal/card button, and Rails always re-renders the
// <details> closed — so without this, "Registrar gol/cartão" snaps shut
// after every single tap, forcing the referee to reopen it and re-find the
// player each time. We remember the open/closed state per game in
// sessionStorage and restore it as soon as the element reconnects.
export default class extends Controller {
  static values = { key: String }

  connect() {
    if (sessionStorage.getItem(this.storageKey) === "1") {
      this.element.open = true
    }
  }

  save() {
    sessionStorage.setItem(this.storageKey, this.element.open ? "1" : "0")
  }

  get storageKey() {
    return `lifDisclosureOpen:${this.keyValue}`
  }
}
